import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.isDragging = false
    this.startX = 0
    this.startY = 0
    this.scrollLeft = 0
    this.pointerId = null
  }

  disconnect() {
    if (this.pointerId !== null) {
      try {
        this.element.releasePointerCapture(this.pointerId)
      } catch (e) {
        // ignore
      }
    }
  }

  wheel(event) {
    if (this.element.scrollWidth <= this.element.clientWidth) return
    if (event.deltaX !== 0) return

    event.preventDefault()
    this.element.scrollLeft += event.deltaY
  }

  pointerDown(event) {
    if (event.pointerType === "touch") return

    this.isDragging = false
    this.startX = event.pageX
    this.startY = event.pageY
    this.scrollLeft = this.element.scrollLeft
    this.pointerId = event.pointerId

    try {
      this.element.setPointerCapture(event.pointerId)
    } catch (e) {
      // ignore
    }
  }

  pointerMove(event) {
    if (event.pointerType === "touch") return
    if (this.pointerId !== event.pointerId) return

    const dx = event.pageX - this.startX
    const dy = event.pageY - this.startY

    if (!this.isDragging && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
      this.isDragging = true
    }

    if (this.isDragging) {
      event.preventDefault()
      this.element.scrollLeft = this.scrollLeft - dx
    }
  }

  pointerUp(event) {
    if (event.pointerType === "touch") return
    if (this.pointerId !== event.pointerId) return

    this.pointerId = null
    try {
      this.element.releasePointerCapture(event.pointerId)
    } catch (e) {
      // ignore
    }
  }

  click(event) {
    if (this.isDragging) {
      event.preventDefault()
      event.stopPropagation()
      this.isDragging = false
    }
  }
}
